import {RepoIcon, CommentDiscussionIcon} from '@primer/octicons-react'

import {Link} from '@primer/react'

import type {McpDetails} from '../../../../types'

import {About} from '../About/About'

import styles from './Sidebar.module.css'

type Props = {
  mcp: McpDetails
}

export function Sidebar({mcp}: Props) {
  return (
    <aside className={styles.sidebar}>
      <div className={styles.onlyDesktop}>
        <h2 className="sr-only">About</h2>

        <About mcp={mcp} />
      </div>

      {mcp.topics && mcp.topics.length > 0 ? (
        <div className={[styles.sidebarStack, styles.withBorder].join(' ')}>
          <div className={styles.tagsHeader}>
            <h2 className="h5">Tags</h2>

            <div className={styles.tagsCount}>{mcp.topics.length}</div>
          </div>

          <div className={styles.tags}>
            {mcp.topics.map(topic => (
              <span key={topic} className={styles.tag}>
                {topic}
              </span>
            ))}
          </div>
        </div>
      ) : null}

      <div className={[styles.sidebarStack, styles.withBorder].join(' ')}>
        <h2 className="h5">Resources</h2>

        <ul className={styles.resourceLinks}>
          {mcp.name_with_owner ? (
            <li>
              <Link href={`/${mcp.name_with_owner}`} muted className={styles.resourceLink}>
                <RepoIcon size={16} />
                View source code
              </Link>
            </li>
          ) : null}

          <li>
            <Link href="https://support.github.com/" muted className={styles.resourceLink}>
              <CommentDiscussionIcon size={16} />
              Support
            </Link>
          </li>
        </ul>
      </div>

      {mcp.pushed_at ? (
        <p className={[styles.text, styles.withBorder].join(' ')}>
          <span className={styles.bold}>Last updated:</span> <relative-time datetime={mcp.pushed_at} tense="past" />
        </p>
      ) : null}
    </aside>
  )
}

try{ Sidebar.displayName ||= 'Sidebar' } catch {}